// import React from 'react';
import React, { useState } from 'react';
import {
  Box,
  Stack,
  Typography,
  Button,
  Grow,
  Card,
  Divider,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from '@mui/material';
import { Icon } from '@iconify/react';
import arrowCircleRightFill from '@iconify/icons-eva/arrow-circle-right-fill';
import bookOpenFill from '@iconify/icons-eva/book-open-fill';
import messageCircleFill from '@iconify/icons-eva/message-circle-fill';
import CloseIcon from '@iconify/icons-eva/close-outline';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import jwt from 'jsonwebtoken';
import { decrypt } from '../../utils/decryptor';
import Logo from '../Logo';

export default function Header({ user }) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  // URL of the PDF file
  const pdfUrl = 'static/kebijakan_layanan.pdf';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>Kebijakan Layanan Data Center</DialogTitle>
        <DialogContent>
          <iframe
            src={pdfUrl}
            title="PDF Viewer"
            width="100%"
            height="500px"
            style={{ border: 'none' }}
          />
        </DialogContent>
      </Dialog>
      <Box
        component={Card}
        py={2}
        px={4}
        sx={{
          boxShadow: 0,
          borderRadius: 0,
          height: 'auto',
          bgcolor: '#FFFFFF',
          display: 'flex',
          minWidth: '100vw',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: { xs: 'center', sm: 'space-between' }
        }}
      >
        <Stack
          direction="row"
          p={2}
          alignItems="center"
          component={RouterLink}
          sx={{ color: theme.palette.grey[700], textDecoration: 'none' }}
          to="/"
        >
          <Logo sx={{ width: 75, height: 75 }} />
          <Stack direction="column" p={2}>
            <Typography variant="h3">
              PELADEN{' '}
              {['DEVELOPMENT', 'STAGING'].includes(process.env.REACT_APP_STAGE) && 'DEVELOPMENT'}
            </Typography>
            <Typography variant="body2">
              <b>Pe</b>ngelolaan <b>La</b>yanan A<b>d</b>ministrasi Sist<b>e</b>m Elektro<b>n</b>ik
              Pemda DIY
            </Typography>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={2} p={2}>
          <Grow in="true">
            <Button
              onClick={handleOpen}
              variant="contained"
              startIcon={<Icon icon={bookOpenFill} />}
            >
              Kebijakan Layanan
            </Button>
          </Grow>
          <Grow in="true">
            <Button
              onClick={() =>
                window.open('https://wiki.jogjaprov.go.id/diskominfo/manual-peladen', '_blank')
              }
              variant="contained"
              startIcon={<Icon icon={bookOpenFill} />}
            >
              Manual
            </Button>
          </Grow>
          <Grow in="true" timeout={1000}>
            <Button
              onClick={() =>
                window.open('https://wa.me/6282133576291?text=Hello Diskominfo DIY...', '_blank')
              }
              variant="contained"
              startIcon={<Icon icon={messageCircleFill} />}
            >
              Helpdesk
            </Button>
          </Grow>
          <Grow in="true" timeout={2000}>
            <Button
              component={RouterLink}
              to={user?.id ? '/dashboard' : '/login'}
              variant="contained"
              startIcon={<Icon icon={arrowCircleRightFill} />}
            >
              {user?.id ? 'Admin' : 'Login'}
            </Button>
          </Grow>
        </Stack>
      </Box>
    </>
  );
}
